import Builder from './Builder.js';
import CampaignContext from '../Campaign.js';
import GaCookie from '../../GaCookie.js';

export default class Campaign extends Builder {
  constructor() {
    super();
    this._setupContext();
  }

  _setupContext() {
    const ga = new GaCookie();
    if (!ga.isEmpty()) {
      this.context = new CampaignContext(ga.source, ga.medium, ga.campaign, ga.term, ga.content);
    }
  }
}
